import Nav from "./components/Nav.jsx";
import Hero from "./components/Hero.jsx";
import About from "./components/About.jsx";
import Why from "./components/Why.jsx";
import Services from "./components/Services.jsx";
import Exp from "./components/Exp.jsx";
import Ask from "./components/Ask.jsx";
import Bolg from "./components/Bolg.jsx"
import Videos from "./components/Videos.jsx";
import Footer from "./components/Footer.jsx";
import ContactUs from "./components/Contact.jsx";
function App() {
  return (
    <div className="App">
      <Nav />
      <Hero />
      <About />
      <Why />
      <Services />
      <Exp />
      <Ask />
      <Bolg />
      <Videos />
      <ContactUs />
      <Footer />
    </div>
  );
}

export default App;
